export default { // 该需求云运行在评估师app，入口接单设置
  tabs: [
    {
      name: 'performance',
      path: '/performance',
      component: () => import('./src/performance.vue'),
      meta: {
        title: '履约控制',
        isMenu: true,
        rule: 'performance'
      }
    }
  ]
}
